import React, { useState, useEffect } from 'react';

import termpHero from '../assets/heroImageTemp.jpg';
import heroImageTempM from '../assets/heroImageTempM.jpg';

const Hero = () => {
  const [width, setWidth] = useState(window.innerWidth);

  const breakpoints = {
    sm: 500,
    tab: 768,
    md: 1024,
    lg: 1280,
    xl: 1440
  };

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <div className="hero">
      <img
        src={width <= breakpoints.sm ? heroImageTempM : termpHero}
        alt="hero"
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default Hero;
